/* V_PT_PDP_13 | Display image with gifts when subscription is ON — shipped to production
   as the default (Var A winner, tests 493f2516-6b36-4ead-84b6-ea43d4610be3 and duplicate
   rerun 9bbdde88-aff2-4320-9038-27fe94d1e08b). */
(function () {
  'use strict';

  var ACTIVE_CLASS = 'c-V_PT_PDP_13-active';
  var SRCSET_WIDTHS = [375, 550, 750, 1100, 1500];
  var started = false;

  // Build a responsive srcset from a single Shopify CDN url by rewriting its width param.
  // Keeps the inline JSON map tiny (one url per variant) while still serving the right size.
  function buildSrcset(url) {
    if (!url || !/[?&]width=\d+/.test(url)) return '';
    return SRCSET_WIDTHS.map(function (w) {
      return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function start() {
    if (started) return;

    var form = document.querySelector('.form-subscription');
    var dataEl = document.querySelector('.c-V_PT_PDP_13-sub-images');
    var abtestDataEl = document.querySelector('.c-RA_PT_PDP_4-sub-images-abtest');
    var media = document.querySelector('#product-media-v2');
    if (!form || !(dataEl || abtestDataEl) || !media) return;

    started = true;

    function parseMap(el) {
      if (!el) return {};
      try {
        return JSON.parse((el.textContent || '{}').trim() || '{}');
      } catch (e) {
        return {};
      }
    }

    var map = parseMap(dataEl);
    // RA_PT_PDP_4 | Free Travel Mug — Var A gets the gift image that still shows the mug.
    // Variants without an `_abtest` image fall through to the control map below.
    var abtestMap = parseMap(abtestDataEl);

    var variantInput = form.querySelector('input[name="id"]');
    var swapped = [];
    var applying = false;
    var raf = null;

    // The visible main image is whichever slide the theme marks `full-width` for the
    // current variant (it re-assigns this on flavour change). Falling back to the active
    // / first visible slide keeps us robust for single-image products.
    function mainSlide() {
      return (
        media.querySelector('.swiper-main .swiper-slide.full-width') ||
        media.querySelector('.swiper-main .swiper-slide.swiper-slide-active') ||
        media.querySelector('.swiper-main .swiper-slide:not(.hidden)')
      );
    }

    function thumbImg() {
      var slide =
        media.querySelector('.swiper-thumb .swiper-slide.full-width-thumb') ||
        media.querySelector('.swiper-thumb .swiper-slide.show') ||
        media.querySelector('.swiper-thumb .swiper-slide:not(.hidden)');
      return slide ? slide.querySelector('.swiper-slide__image > img') : null;
    }

    function zoomImg(index) {
      if (index == null) return null;
      var slide = document.querySelector(
        '.modal-product-media .swiper-zoom .swiper-slide[data-index="' + index + '"]'
      );
      return slide ? slide.querySelector('.swiper-slide__image > img') : null;
    }

    function swapImg(img, url, sizes) {
      if (!img || img.dataset.c13Swapped === '1') return;
      img.dataset.c13Src = img.getAttribute('src') || '';
      img.dataset.c13Srcset = img.getAttribute('srcset') || '';
      img.dataset.c13Sizes = img.getAttribute('sizes') || '';

      var srcset = buildSrcset(url);
      img.setAttribute('src', url);
      if (srcset) {
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (sizes) img.setAttribute('sizes', sizes);
      img.classList.add(ACTIVE_CLASS);
      img.dataset.c13Swapped = '1';
      swapped.push(img);
    }

    function restoreAll() {
      swapped.forEach(function (img) {
        if (img.dataset.c13Swapped !== '1') return;
        img.setAttribute('src', img.dataset.c13Src || '');
        if (img.dataset.c13Srcset) {
          img.setAttribute('srcset', img.dataset.c13Srcset);
        } else {
          img.removeAttribute('srcset');
        }
        if (img.dataset.c13Sizes) {
          img.setAttribute('sizes', img.dataset.c13Sizes);
        } else {
          img.removeAttribute('sizes');
        }
        img.classList.remove(ACTIVE_CLASS);
        delete img.dataset.c13Swapped;
        delete img.dataset.c13Src;
        delete img.dataset.c13Srcset;
        delete img.dataset.c13Sizes;
      });
      swapped = [];
    }

    function apply() {
      applying = true;

      var active = form.dataset.subscriptionActive === 'true';
      var variantId = variantInput ? String(variantInput.value) : '';
      var url =
        (window.cFreeTravelMugVarA && window.cFreeTravelMugVarA() && abtestMap[variantId]) ||
        map[variantId];

      restoreAll();

      if (!active || !url) {
        document.body.classList.remove('c-V_PT_PDP_13-sub-on');
        applying = false;
        return;
      }

      var slide = mainSlide();
      if (slide) {
        var mainImg = slide.querySelector('.swiper-slide__image > img');
        swapImg(mainImg, url, (mainImg && mainImg.getAttribute('sizes')) || '80vw');
        swapImg(zoomImg(slide.getAttribute('data-index')), url, '100vw');
      }
      swapImg(thumbImg(), url, '(min-width: 769px) 60px, 20vw');

      document.body.classList.add('c-V_PT_PDP_13-sub-on');
      applying = false;
    }

    function scheduleApply() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        apply();
      });
    }

    apply();

    // Subscription toggle flips data-subscription-active on the form container.
    new MutationObserver(apply).observe(form, {
      attributes: true,
      attributeFilter: ['data-subscription-active'],
    });

    // Flavor / quantity / person clicks change the variant. The form's own handlers call
    // stopPropagation(), so we listen in the CAPTURE phase (runs before stopPropagation).
    form.addEventListener(
      'click',
      function (e) {
        if (
          e.target.closest(
            '.form-subscription__variant, .form-subscription__flavor-btn, .form-subscription__person'
          )
        ) {
          scheduleApply();
        }
      },
      true
    );

    var variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      variantPicker.addEventListener('on:variant:change', scheduleApply);
    }

    // The theme moves the `full-width` class onto the now-visible slide when the variant
    // changes. Re-target whenever the gallery's slide classes change so the gift image
    // always follows the displayed image (this is what previously failed on multi-flavour
    // products). Ignore our own class writes (which only touch <img> elements).
    var mainSwiper = media.querySelector('.swiper-main');
    if (mainSwiper) {
      new MutationObserver(function (mutations) {
        if (applying) return;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].target.tagName !== 'IMG') {
            scheduleApply();
            return;
          }
        }
      }).observe(mainSwiper, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // Safety net for RA_PT_PDP_4 in case igData was not populated yet on the first apply().
    window.addEventListener('ig:ready', scheduleApply);

    // The subscription form resolves its default variant asynchronously during init
    // (without a click). Re-apply a couple of times shortly after start to catch it.
    setTimeout(apply, 200);
    setTimeout(apply, 600);
  }

  start();
  document.addEventListener('DOMContentLoaded', start);
})();
